module.exports = __webpack_public_path__ + "static/image/history/m/201707@3x.jpg?a423eae2";